module.exports = __webpack_public_path__ + "static/media/tanque-verde.c42630bc.svg";